var _circle, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.875,
    r: 14,
    stroke: "#FF4E5E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 10.875C17.5 9.49625 16.3787 8.375 15 8.375C13.6213 8.375 12.5 9.49625 12.5 10.875C12.5 12.2537 13.6213 13.375 15 13.375C16.3787 13.375 17.5 12.2537 17.5 10.875ZM20 10.875C20 13.6325 17.7575 15.875 15 15.875C12.2425 15.875 10 13.6325 10 10.875C10 8.1175 12.2425 5.875 15 5.875C17.7575 5.875 20 8.1175 20 10.875ZM6.25 27.125C6.25 22.3 10.1762 18.375 15 18.375C19.8237 18.375 23.75 22.3 23.75 27.125C23.75 27.815 23.1912 28.375 22.5 28.375C21.8088 28.375 21.25 27.815 21.25 27.125C21.25 23.6787 18.4462 20.875 15 20.875C11.5538 20.875 8.75 23.6787 8.75 27.125C8.75 27.815 8.19125 28.375 7.5 28.375C6.80875 28.375 6.25 27.815 6.25 27.125Z",
    fill: "#FF4E5E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_841_4919",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 18,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 10.875C17.5 9.49625 16.3787 8.375 15 8.375C13.6213 8.375 12.5 9.49625 12.5 10.875C12.5 12.2537 13.6213 13.375 15 13.375C16.3787 13.375 17.5 12.2537 17.5 10.875ZM20 10.875C20 13.6325 17.7575 15.875 15 15.875C12.2425 15.875 10 13.6325 10 10.875C10 8.1175 12.2425 5.875 15 5.875C17.7575 5.875 20 8.1175 20 10.875ZM6.25 27.125C6.25 22.3 10.1762 18.375 15 18.375C19.8237 18.375 23.75 22.3 23.75 27.125C23.75 27.815 23.1912 28.375 22.5 28.375C21.8088 28.375 21.25 27.815 21.25 27.125C21.25 23.6787 18.4462 20.875 15 20.875C11.5538 20.875 8.75 23.6787 8.75 27.125C8.75 27.815 8.19125 28.375 7.5 28.375C6.80875 28.375 6.25 27.815 6.25 27.125Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_841_4919)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 2.125,
    width: 30,
    height: 30,
    fill: "#FF4E5E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.60ceadc2f29db0d8a64445abdecd1a54.svg";
export { ForwardRef as ReactComponent };